import { randNumber, randCurrencyCode } from '@ngneat/falso';

import { Customs } from '../base';

export class MockCustoms implements Customs {
   value: number;
   currency: string;

   constructor() {
      this.value = randNumber();
      this.currency = randCurrencyCode();
   }
}
